document.addEventListener('DOMContentLoaded', () => {
  const table = document.querySelector('#e-invoices-table');
  if (!table) return;

  const subCompanyNamesTd = table.querySelectorAll('td.sub-company-name');
  const subCompanyInput = document.querySelector('#sub_company_name');
  const subCompanyIdInput = document.querySelector('#sub_company_id');
  const combobox = subCompanyInput ? subCompanyInput.closest('[data-combobox]') : null;
  const form = document.querySelector('form#select-company-e-invoices');

  if (!combobox) return;

  // Keyed on the CIF the cell carries, not on the name it shows: the name is
  // truncated at 40 characters, so matching the datalist by its text could never
  // work for a long one - and the old code read .value off the undefined option
  // before checking it, so it threw rather than falling through.
  subCompanyNamesTd.forEach(subCompanyNameTd => {
    subCompanyNameTd.addEventListener('click', () => {
      const id = subCompanyNameTd.dataset.subCompanyId
      if (!id || id === subCompanyIdInput.value) return

      const options = Array.from(combobox.querySelectorAll('.combobox__option'))
      const matchingOption = options.find(option => option.dataset.id === id)
      if (!matchingOption) return

      subCompanyInput.value = matchingOption.dataset.label
      subCompanyIdInput.value = id
      form.submit()
    });
  });
});
